import {
  ADD_PROJECT,
  EDIT_PROJECT,
  GET_PROJECTS,
  GET_PROJECT_BY_ID,
  REMOVE_PROJECT,
} from "../actions/project-actions";
import { ApiRequestState } from "../../types/state-management";

const initialState = {
  loading: false,
  data: [],
  error: null,
};

const projectReducer = (state = initialState, action: any): ApiRequestState => {
  switch (action.type) {
    case (ADD_PROJECT.REQUEST,
    GET_PROJECTS.REQUEST,
    GET_PROJECT_BY_ID.REQUEST,
    EDIT_PROJECT.REQUEST,
    REMOVE_PROJECT.REQUEST):
      return {
        ...state,
        loading: true,
        error: null,
      };
    case (ADD_PROJECT.SUCCESS,
    GET_PROJECTS.SUCCESS,
    GET_PROJECT_BY_ID.SUCCESS,
    EDIT_PROJECT.SUCCESS,
    REMOVE_PROJECT.SUCCESS):
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case (ADD_PROJECT.FAILURE,
    GET_PROJECTS.FAILURE,
    GET_PROJECT_BY_ID.FAILURE,
    EDIT_PROJECT.FAILURE,
    REMOVE_PROJECT.FAILURE):
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export { projectReducer };
